/** Generated js for domain-specific scripting
 * by common\modules\domains\helpers\DomainJavascriptWriter
 */


/* expander */
if (document.querySelector('#beforeafterslider')) {
  new BeforeAfter({ id: '#beforeafterslider' });
}

document.addEventListener('click', function (event) {
  const isExpandButton =
    event.target.matches('.expand-button') ||
    event.target.closest('.expand-button') !== null;

  const expanderParent = event.target.closest('.expander');

  if (isExpandButton && expanderParent) {
    event.preventDefault();
    toggleExpander(expanderParent, true);
  }
});

function toggleExpander(expanderElement, toggle) {
  if (toggle) {
    expanderElement.classList.toggle('expand');
  }
  let maxHeight = '999em';
  if (!expanderElement.classList.contains('expand')) {
    maxHeight = expanderElement.dataset.minimalHeight ?? '50px';
  }
  const contentElement = expanderElement.querySelector('.expander-content');
  if (contentElement) {
    contentElement.style.maxHeight = maxHeight;
  }
}

document.querySelectorAll('.expander').forEach(expander => {
  toggleExpander(expander, false);
});


/* KAVELKIEZER V3 */
(function() {
    'use strict';

    const mapViewsContainer = document.getElementById('mapViews');
    if (!mapViewsContainer) return;

    // Korte helper voor getElementById
    const $ = id => document.getElementById(id);

    const wrapper    = $('mapWrapper'),   svg       = $('kavelSvg'),
          bgImg      = $('mapCanvas'),    tooltip   = $('kavelTooltip'),
          tooltipOverview = $('kavelTooltipOverview'),
          panel      = $('detailsPanel'), overlayBg = $('overlayBg'),
          mapContainer = document.querySelector('.map-container'),
          kavelApp   = $('kavelApp'),
          btnBackOverview = $('btnBackOverview');

    if (!wrapper || !svg || !bgImg || !tooltip || !panel || !overlayBg || !mapContainer) {
        console.warn('Kavelkiezer: niet alle vereiste elementen aanwezig'); return;
    }

    const viewMapBtn = $('viewMapBtn'), viewListBtn = $('viewListBtn'),
          viewMapBtnMobile = $('viewMapBtnMobile'), viewListBtnMobile = $('viewListBtnMobile'),
          pricelistContainer = $('pricelistContainer'), pricelistBody = $('pricelistBody'),
          pricelistEmpty = $('pricelistEmpty'), filterStatus = $('filterStatus'),
          filterType = $('filterType'), filterModel = $('filterModel'),
          filterBedrooms = $('filterBedrooms'), resetBtn = $('resetFilters'),
          resultsCounter = $('resultsCounter'), mobileResultsCounter = $('mobileResultsCounter'),
          mobileFilterBtn = $('mobileFilterBtn'), mobileFilterBadge = $('mobileFilterBadge'),
          filterDrawer = $('filterDrawer'), filterDrawerOverlay = $('filterDrawerOverlay'),
          filterDrawerClose = $('filterDrawerClose'), filterDrawerReset = $('filterDrawerReset'),
          filterDrawerApply = $('filterDrawerApply'), filterStatusMobile = $('filterStatusMobile'),
          filterTypeMobile = $('filterTypeMobile'), filterModelMobile = $('filterModelMobile'),
          filterBedroomsMobile = $('filterBedroomsMobile'), moreFiltersBtn = $('moreFiltersBtn'),
          moreFiltersDropdown = $('moreFiltersDropdown'), moreFiltersBadge = $('moreFiltersBadge'),
          filterModelDropdown = $('filterModelDropdown'), filterBedroomsDropdown = $('filterBedroomsDropdown'),
          viewSelect = $('viewSelect'), viewPrev = $('viewPrev'), viewNext = $('viewNext');

    // Views inladen — .d-none views worden overgeslagen (handig om overview
    // of een detail-view tijdelijk uit te schakelen zonder HTML te verwijderen)
    const mapViews = Array.from(mapViewsContainer.querySelectorAll('.map-view'))
        .filter(v => !v.classList.contains('d-none'));
    const views = mapViews.map((v, i) => ({
        index: i, id: v.dataset.id, label: v.dataset.label,
        background: v.dataset.background, viewBox: v.dataset.vb || '0 0 1920 1080',
        type: v.dataset.viewType || 'detail'  // 'overview' of 'detail'
    }));

    // Indices van detail-views (voor prev/next navigatie, zonder overview)
    const detailViewIndices = views.map((v, i) => v.type === 'detail' ? i : -1).filter(i => i >= 0);
    const overviewIndex = views.findIndex(v => v.type === 'overview');
    const hasOverview = overviewIndex >= 0;

    // View-select dropdown vullen (overview krijgt een visueel onderscheid)
    views.forEach((v, i) => {
        const opt = document.createElement('option');
        opt.value = i;
        opt.textContent = v.type === 'overview' ? '↩ ' + v.label : v.label;
        viewSelect.appendChild(opt);
    });

    // --- Helpers ---
    function parsePrice(s) {
        const m = s && s.match(/€?\s*([\d.,]+)/);
        return m ? parseInt(m[1].replace(/[^\d]/g, '')) || 0 : 0;
    }
    function parseM2(s) {
        const m = s && s.match(/(\d+)/);
        return m ? parseInt(m[1]) : 0;
    }
    function formatPriceShort(v) {
        return v >= 1000000 ? '€' + (v / 1000000).toFixed(1) + 'M' : '€' + Math.round(v / 1000) + 'k';
    }
    function statusToKey(s) {
        return s ? s.toLowerCase().trim().replace(/\s+/g, '-') : 'toekomstig';
    }
    // Stel tekst in van element (null-safe)
    function setText(id, text) { const e = $(id); if (e) e.textContent = text; }
    // Toon/verberg dd + bijbehorende dt
    function showDd(id, show) {
        const e = $(id); if (!e) return;
        e.style.display = show ? '' : 'none';
        if (e.previousElementSibling) e.previousElementSibling.style.display = e.style.display;
    }
    // Toon/verberg spec-tag
    function showTag(id, show) { const e = $(id); if (e) e.style.display = show ? '' : 'none'; }

    // Check of huidige view een overview is
    function isOverviewView() {
        return views[currentViewIndex] && views[currentViewIndex].type === 'overview';
    }

    // Status → leesbaar label
    const STATUS_LABELS = {
        'available':'Beschikbaar','beschikbaar':'Beschikbaar','vrij':'Beschikbaar','te-koop':'Te koop',
        'option':'Onder optie','optie':'Onder optie','onder-optie':'Onder optie','in-optie':'Onder optie',
        'onder-bod':'Onder bod','oral-agreement':'Mondeling verkocht','mondeling-verkocht':'Mondeling verkocht',
        'verhuurd':'Verhuurd','verhuurd-onder-voorbehoud':'Verhuurd o.v.',
        'sold':'Verkocht','verkocht':'Verkocht','verkoht':'Verkocht',
        'verkocht-onder-voorbehoud':'Verkocht o.v.','future':'Toekomstig','toekomstig':'Toekomstig',
        'in-aanmelding':'In aanmelding','nog-niet-in-verkoop':'Nog niet in verkoop','binnenkort':'Binnenkort',
        'binnenkort-in-verkoop':'Binnenkort in verkoop',
    };
    function statusToLabel(s) { return STATUS_LABELS[statusToKey(s)] || s || 'Toekomstig'; }

    // Status → badge CSS klasse (panel + tooltip)
    const BADGE = {
        'available':'bg-success text-white','beschikbaar':'bg-success text-white',
        'vrij':'bg-success text-white','te-koop':'bg-success text-white',
        'option':'bg-warning text-dark','optie':'bg-warning text-dark',
        'onder-optie':'bg-warning text-dark','in-optie':'bg-warning text-dark','onder-bod':'bg-warning text-dark',
        'oral-agreement':'bg-oral-agreement','mondeling-verkocht':'bg-oral-agreement',
        'verhuurd':'bg-rented','verhuurd-onder-voorbehoud':'bg-rented',
        'sold':'bg-danger','verkocht':'bg-danger','verkoht':'bg-danger',
        'verkocht-onder-voorbehoud':'bg-sold-option', 'binnenkort-in-verkoop':'bg-success text-white',
    };
    function statusToBadgeClass(s) { return BADGE[statusToKey(s)] || 'bg-future'; }

    const TOOLTIP_BADGE = {
        'available':'bg-available','beschikbaar':'bg-available','vrij':'bg-available','te-koop':'bg-available',
        'option':'bg-option','optie':'bg-option','onder-optie':'bg-option','in-optie':'bg-option','onder-bod':'bg-option',
        'oral-agreement':'bg-oral-agreement','mondeling-verkocht':'bg-oral-agreement',
        'verhuurd':'bg-rented','verhuurd-onder-voorbehoud':'bg-rented',
        'sold':'bg-sold','verkocht':'bg-sold','verkoht':'bg-sold','verkocht-onder-voorbehoud':'bg-sold-option',
        'binnenkort-in-verkoop':'bg-available',
    };
    function statusToTooltipBadge(s) { return TOOLTIP_BADGE[statusToKey(s)] || 'bg-future'; }

    // Situatie codes → leesbare labels
    const SITUATIE = {
        'water':'Aan water','clear_view':'Vrij uitzicht','rural':'Landelijk',
        'forest':'Aan bos','park':'Aan park','open':'Open ligging',
        'sheltered':'Beschut','sea_view':'Zeezicht'
    };
    function situatieToLabels(s) {
        return s ? s.split(',').map(x => SITUATIE[x.trim()]).filter(Boolean) : [];
    }

    // Parkeren → leesbare tekst
    const PARKEER = { 'private':'Eigen parkeren','garage':'Garage','carport':'Carport','public':'Openbaar','paid':'Betaald parkeren' };
    function parkerenLabel(fac, cap) {
        if (!fac || fac === 'none') return '';
        const label = PARKEER[fac] || fac;
        return (cap && parseInt(cap) > 0) ? label + ' (' + cap + ' pl.)' : label;
    }

    // --- Data analyse ---
    function analyzeKavelData() {
        const statuses = new Set(), types = new Set(), models = new Set(), bedrooms = new Set();
        let minP = Infinity, maxP = 0, minM = Infinity, maxM = 0, minPc = Infinity, maxPc = 0, total = 0;
        const seen = new Set();
        // Alleen detail-views scannen (overview bevat side-polygons, geen woningen)
        mapViews.forEach(view => {
            if (view.dataset.viewType === 'overview') return;
            view.querySelectorAll('path').forEach(p => {
                if (seen.has(p.dataset.id)) return;
                seen.add(p.dataset.id); total++;
                if (p.dataset.status) statuses.add(statusToKey(p.dataset.status));
                if (p.dataset.naam) types.add(p.dataset.naam);
                if (p.dataset.typewoning) models.add(p.dataset.typewoning);
                const bed = (p.dataset.aantalKamers || p.dataset.aantalSlaapkamers || '').replace(/[^\d]/g, '');
                if (bed) bedrooms.add(bed);
                const pr = parsePrice(p.dataset.prijs); if (pr > 0) { minP = Math.min(minP, pr); maxP = Math.max(maxP, pr); }
                const m2 = parseM2(p.dataset.woonoppervlakte); if (m2 > 0) { minM = Math.min(minM, m2); maxM = Math.max(maxM, m2); }
                const pc = parseM2(p.dataset.perceeloppervlakte); if (pc > 0) { minPc = Math.min(minPc, pc); maxPc = Math.max(maxPc, pc); }
            });
        });
        return {
            statuses: [...statuses], types: [...types].sort(), models: [...models].sort(),
            bedrooms: [...bedrooms].sort((a, b) => a - b), total,
            priceRange:  { min: minP  === Infinity ? 0 : minP,  max: maxP  },
            m2Range:     { min: minM  === Infinity ? 0 : minM,  max: maxM  },
            perceelRange:{ min: minPc === Infinity ? 0 : minPc, max: maxPc }
        };
    }
    const kavelData = analyzeKavelData();

    // --- Filters setup ---
    function setFilterVisible(id, visible) {
        const e = $(id); if (e) e.classList.toggle('filter-hidden', !visible);
    }
    function addOptions(selects, items, labelFn) {
        selects.forEach(sel => {
            if (!sel) return;
            items.forEach(v => { const o = document.createElement('option'); o.value = v; o.textContent = labelFn ? labelFn(v) : v; sel.appendChild(o); });
        });
    }

    function setupFilters() {
        const { statuses, types, models, bedrooms, priceRange: pr, m2Range: m2, perceelRange: pc, total: n } = kavelData;

        const showSt = n > 0 && statuses.length > 1;
        setFilterVisible('filterStatusWrap', showSt); setFilterVisible('filterStatusMobileWrap', showSt);
        if (showSt) {
            const order = ['available','option','oral-agreement','rented','sold','future'];
            addOptions([filterStatus, filterStatusMobile], [...statuses].sort((a, b) => order.indexOf(a) - order.indexOf(b)), statusToLabel);
        }

        const showTy = n > 0 && types.length > 1;
        setFilterVisible('filterTypeWrap', showTy); setFilterVisible('filterTypeMobileWrap', showTy);
        if (showTy) addOptions([filterType, filterTypeMobile], types);

        const showMo = n > 0 && models.length > 1;
        ['filterModelWrap','filterModelMobileWrap','filterModelWrapDropdown'].forEach(id => setFilterVisible(id, showMo));
        if (showMo) addOptions([filterModel, filterModelMobile, filterModelDropdown], models);

        const showBed = n > 0 && bedrooms.length > 1;
        ['filterBedroomsWrap','filterBedroomsMobileWrap','filterBedroomsWrapDropdown'].forEach(id => setFilterVisible(id, showBed));
        if (showBed) addOptions([filterBedrooms, filterBedroomsMobile, filterBedroomsDropdown], bedrooms,
            b => b + ' slaapkamer' + (parseInt(b) !== 1 ? 's' : ''));

        const showPr = n > 0 && pr.max > 0 && pr.min < pr.max;
        const showM2 = n > 0 && m2.max > 0 && m2.min < m2.max;
        const showPc = n > 0 && pc.max > 0 && pc.min < pc.max;
        ['filterPriceWrap','filterPriceMobileWrap'].forEach(id => setFilterVisible(id, showPr));
        ['filterM2Wrap','filterM2MobileWrap','filterM2WrapDropdown'].forEach(id => setFilterVisible(id, showM2));
        ['filterPerceelWrap','filterPerceelMobileWrap','filterPerceelWrapDropdown'].forEach(id => setFilterVisible(id, showPc));
        return { showPr, showM2, showPc, pr, m2, pc };
    }
    const fc = setupFilters(); // fc = filterConfig

    // --- State ---
    let activeStatusFilter = '', activeTypeFilter = '', activeModelFilter = '', activeBedroomsFilter = '';
    let activeView = 'map', sortColumn = 'bouwnummer', sortDirection = 'asc', isInitialized = false;

    const priceMin = fc.showPr ? Math.floor(fc.pr.min / 10000) * 10000 : 200000;
    const priceMax = fc.showPr ? Math.ceil(fc.pr.max / 10000) * 10000  : 1000000;
    const m2Min    = fc.showM2 ? Math.floor(fc.m2.min / 5) * 5         : 40;
    const m2Max    = fc.showM2 ? Math.ceil(fc.m2.max / 5) * 5          : 200;
    const pcMin    = fc.showPc ? Math.floor(fc.pc.min / 10) * 10       : 100;
    const pcMax    = fc.showPc ? Math.ceil(fc.pc.max / 10) * 10        : 500;

    let priceRange = [priceMin, priceMax], m2Range = [m2Min, m2Max], pcRange = [pcMin, pcMax];
    let isOpen = false, pinnedId = null, currentViewIndex = 0, scale = 1, panX = 0, panY = 0;
    const MIN_SCALE = 1, MAX_SCALE = 5;

    // --- Kavel data verzamelen ---
    // BELANGRIJK: moet VOOR createSlider() declareerd zijn, omdat de slider-init
    // callbacks direct applyFilters() kunnen triggeren die allKavels gebruikt.
    function getAllKavels() {
        const kavels = [], seen = new Set();
        // Alleen detail-views scannen
        mapViews.forEach(view => {
            if (view.dataset.viewType === 'overview') return;
            view.querySelectorAll('path').forEach(p => {
                if (seen.has(p.dataset.id)) return;
                seen.add(p.dataset.id);
                const d = p.dataset, km = d.aantalKamers || d.aantalSlaapkamers || '';
                const m2str = val => val && parseFloat(val) !== 0 ? val + ' m\u00B2' : '';
                kavels.push({
                    id: d.id, bouwnummer: d.bouwnummer || '', naam: d.naam || '', typewoning: d.typewoning || '',
                    prijs: d.prijs || '', prijsNum: parsePrice(d.prijs), status: statusToKey(d.status),
                    woonoppervlakte: m2str(d.woonoppervlakte), woonoppervlakteNum: parseM2(d.woonoppervlakte),
                    perceeloppervlakte: m2str(d.perceeloppervlakte), perceeloppervlakteNum: parseM2(d.perceeloppervlakte),
                    buitenruimte: d.buitenruimte || '', verdieping: d.verdieping || '', aantalKamers: km,
                    ligging: d.ligging || '', afbeelding: d.afbeelding || '', info: d.info || '',
                    woonlastenUrl: d.woonlastenUrl || '',
                    volume: d.volume && parseFloat(d.volume) > 0 ? d.volume : '',
                    kamersTotaal: d.kamersTotaal && parseInt(d.kamersTotaal) > 0 ? d.kamersTotaal : '',
                    parkeren: parkerenLabel(d.parkeren, d.parkerenAantal),
                    situatie: d.situatie || ''
                });
            });
        });
        return kavels;
    }
    const allKavels = getAllKavels();

    // --- Dual range sliders ---
    function createSlider(container, start, range, step, onUpdate) {
        if (!container) return null;
        const { min, max } = range;
        let v = [...start];
        const cbs = [];
        container.innerHTML = `<div class="dual-range-slider"><div class="dual-range-track"></div><div class="dual-range-fill"></div><input type="range" class="range-min" min="${min}" max="${max}" step="${step}" value="${start[0]}"><input type="range" class="range-max" min="${min}" max="${max}" step="${step}" value="${start[1]}"></div>`;
        const fill = container.querySelector('.dual-range-fill');
        const rMin = container.querySelector('.range-min');
        const rMax = container.querySelector('.range-max');
        function updateFill() {
            fill.style.left  = ((v[0] - min) / (max - min) * 100) + '%';
            fill.style.width = ((v[1] - v[0]) / (max - min) * 100) + '%';
        }
        rMin.addEventListener('input', () => {
            v[0] = Math.min(parseInt(rMin.value), v[1] - step); rMin.value = v[0]; updateFill(); onUpdate([...v]);
        });
        rMax.addEventListener('input', () => {
            v[1] = Math.max(parseInt(rMax.value), v[0] + step); rMax.value = v[1]; updateFill(); onUpdate([...v]);
        });
        rMin.addEventListener('change', () => cbs.forEach(cb => cb([...v])));
        rMax.addEventListener('change', () => cbs.forEach(cb => cb([...v])));
        updateFill(); onUpdate([...v]);
        return {
            get: () => [...v],
            set: nv => { v = [...nv]; rMin.value = v[0]; rMax.value = v[1]; updateFill(); onUpdate([...v]); },
            on: (ev, cb) => { if (ev === 'change') cbs.push(cb); }
        };
    }

    let priceSlider = null, priceSliderMobile = null, m2Slider = null, m2SliderMobile = null,
        pcSlider = null, pcSliderMobile = null, m2SliderDD = null, pcSliderDD = null;

    if (fc.showPr) {
        priceSlider       = createSlider($('priceSlider'),       [priceMin, priceMax], { min: priceMin, max: priceMax }, 10000, v => { priceRange = v; setText('priceValue', formatPriceShort(v[0]) + ' - ' + formatPriceShort(v[1])); applyFilters(); });
        priceSliderMobile = createSlider($('priceSliderMobile'), [priceMin, priceMax], { min: priceMin, max: priceMax }, 10000, v => setText('priceValueMobile', '€ ' + Number(v[0]).toLocaleString('nl-NL') + ' - € ' + Number(v[1]).toLocaleString('nl-NL')));
    }
    if (fc.showM2) {
        m2Slider    = createSlider($('m2Slider'),       [m2Min, m2Max], { min: m2Min, max: m2Max }, 5, v => { m2Range = v; setText('m2Value', v[0] + ' - ' + v[1] + ' m\u00B2'); applyFilters(); });
        m2SliderMobile = createSlider($('m2SliderMobile'), [m2Min, m2Max], { min: m2Min, max: m2Max }, 5, v => setText('m2ValueMobile', v[0] + ' - ' + v[1] + ' m\u00B2'));
        m2SliderDD  = createSlider($('m2SliderDropdown'), [m2Min, m2Max], { min: m2Min, max: m2Max }, 5, v => { m2Range = v; setText('m2ValueDropdown', v[0] + ' - ' + v[1] + ' m\u00B2'); if (m2Slider) m2Slider.set(v); applyFilters(); });
    }
    if (fc.showPc) {
        pcSlider       = createSlider($('perceelSlider'),       [pcMin, pcMax], { min: pcMin, max: pcMax }, 10, v => { pcRange = v; setText('perceelValue', v[0] + ' - ' + v[1] + ' m\u00B2'); applyFilters(); });
        pcSliderMobile = createSlider($('perceelSliderMobile'), [pcMin, pcMax], { min: pcMin, max: pcMax }, 10, v => setText('perceelValueMobile', v[0] + ' - ' + v[1] + ' m\u00B2'));
        pcSliderDD     = createSlider($('perceelSliderDropdown'), [pcMin, pcMax], { min: pcMin, max: pcMax }, 10, v => { pcRange = v; setText('perceelValueDropdown', v[0] + ' - ' + v[1] + ' m\u00B2'); if (pcSlider) pcSlider.set(v); applyFilters(); });
    }

    // --- Render view ---
    function renderView(idx) {
        const view = views[idx], viewEl = mapViews[idx];
        if (!view || !viewEl) return;
        bgImg.src = view.background;
        svg.setAttribute('viewBox', view.viewBox);
        const [,, vw, vh] = view.viewBox.split(' ').map(Number);
        if (vw && vh) wrapper.style.aspectRatio = vw + ' / ' + vh;
        svg.innerHTML = '';

        // Is dit een overview-view of een detail-view?
        const isOverview = view.type === 'overview';

        // Kopieer alle paths uit de bron-view naar de live SVG
        viewEl.querySelectorAll('path').forEach(p => {
            const path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
            Array.from(p.attributes).forEach(a => path.setAttribute(a.name, a.value));
            svg.appendChild(path);
        });

        // Op detail-views: status-classes toevoegen op basis van data-status
        if (!isOverview) {
            svg.querySelectorAll('.hover-area').forEach(path => {
                Array.from(path.classList).filter(c => c.startsWith('status-')).forEach(c => path.classList.remove(c));
                path.classList.add('status-' + statusToKey(path.dataset.status));
            });
        }

        // Update app-class voor overview-modus (stuurt CSS voor filterbar e.d.)
        kavelApp.classList.toggle('is-overview', isOverview);

        // Terug-knop tonen/verbergen: alleen op detail-views EN als er een overview bestaat
        if (btnBackOverview) {
            btnBackOverview.classList.toggle('is-visible', hasOverview && !isOverview);
        }

        // Op overview: filters mogen niet effectief zijn (alles wordt overschreven naar getoond)
        // maar we resetten ze NIET — gebruiker behoudt filters als ze terugkeren naar detail-view

        // Side-labels renderen op overview, anders opruimen
        if (isOverview) {
            // Wacht tot de browser SVG heeft gelayout (nodig voor getBBox)
            requestAnimationFrame(() => renderSideLabels());
        } else {
            clearSideLabels();
        }

        scale = 1; panX = 0; panY = 0; applyTransform();
        svg.classList.remove('has-selection');
        hideTooltip();
        applyFilters();
    }

    // --- Side labels (overview) ---
    // Permanent zichtbare labels op elke side-polygon, gepositioneerd op het
    // geometrische middelpunt. Trekken de aandacht via subtiele pulse en maken
    // duidelijk dat de zijdes klikbaar zijn.
    function clearSideLabels() {
        wrapper.querySelectorAll('.side-label').forEach(el => el.remove());
    }

    function renderSideLabels() {
        clearSideLabels();
        const polygons = svg.querySelectorAll('.side-polygon');
        if (!polygons.length) return;

        const wrapperRect = wrapper.getBoundingClientRect();
        if (!wrapperRect.width || !wrapperRect.height) return;

        polygons.forEach(poly => {
            // getBBox geeft coördinaten in SVG-userspace. We mappen die via
            // getBoundingClientRect van de polygon naar pixel-coördinaten van de wrapper.
            const polyRect = poly.getBoundingClientRect();
            if (!polyRect.width || !polyRect.height) return;

            const cx = polyRect.left + polyRect.width / 2 - wrapperRect.left;
            const cy = polyRect.top + polyRect.height / 2 - wrapperRect.top;

            const label = document.createElement('div');
            label.className = 'side-label';
            label.style.left = cx + 'px';
            label.style.top = cy + 'px';

            const mainLabel = poly.dataset.label || 'Bekijk aanzicht';
            const subLabel = poly.dataset.sublabel || 'Bekijk dit aanzicht';

            label.innerHTML = `
                <span class="side-label-text">
                    <span>${mainLabel}</span>
                    <span class="side-label-sub">${subLabel}</span>
                </span>
                <span class="side-label-arrow"><i class="fa fa-arrow-right"></i></span>
            `;

            // Koppel label aan polygon voor hover-sync
            label.addEventListener('click', () => handleSidePolygonClick(poly));
            label.addEventListener('mouseenter', () => poly.classList.add('is-hovering'));
            label.addEventListener('mouseleave', () => poly.classList.remove('is-hovering'));

            wrapper.appendChild(label);

            // Koppel terug: wanneer polygon hovered wordt, label "activeren"
            poly._sideLabel = label;
        });
    }

    // Herpositioneer labels bij resize (ze staan in pixels, dus moeten mee)
    if (typeof ResizeObserver !== 'undefined') {
        const ro = new ResizeObserver(() => {
            if (isOverviewView()) requestAnimationFrame(() => renderSideLabels());
        });
        ro.observe(wrapper);
    } else {
        window.addEventListener('resize', () => {
            if (isOverviewView()) requestAnimationFrame(() => renderSideLabels());
        });
    }

    // --- Filter matching ---
    function kavelMatchesFilters(k) {
        if (activeStatusFilter && k.status !== activeStatusFilter) return false;
        if (activeTypeFilter && k.naam.toLowerCase() !== activeTypeFilter) return false;
        if (activeModelFilter && k.typewoning !== activeModelFilter) return false;
        if (activeBedroomsFilter && k.aantalKamers.replace(/[^\d]/g, '') !== activeBedroomsFilter) return false;
        if (fc.showPr && k.prijsNum > 0 && (k.prijsNum < priceRange[0] || k.prijsNum > priceRange[1])) return false;
        if (fc.showM2 && k.woonoppervlakteNum > 0 && (k.woonoppervlakteNum < m2Range[0] || k.woonoppervlakteNum > m2Range[1])) return false;
        if (fc.showPc && k.perceeloppervlakteNum > 0 && (k.perceeloppervlakteNum < pcRange[0] || k.perceeloppervlakteNum > pcRange[1])) return false;
        return true;
    }

    // --- Filters toepassen ---
    function applyFilters() {
        let ac = [activeStatusFilter, activeTypeFilter, activeModelFilter, activeBedroomsFilter].filter(Boolean).length;
        if (fc.showPr && (priceRange[0] > priceMin || priceRange[1] < priceMax)) ac++;
        if (fc.showM2 && (m2Range[0] > m2Min || m2Range[1] < m2Max)) ac++;
        if (fc.showPc && (pcRange[0] > pcMin || pcRange[1] < pcMax)) ac++;
        mobileFilterBadge.textContent = ac || ''; mobileFilterBadge.dataset.count = ac;

        let mc = [activeModelFilter, activeBedroomsFilter].filter(Boolean).length;
        if (fc.showM2 && (m2Range[0] > m2Min || m2Range[1] < m2Max)) mc++;
        if (fc.showPc && (pcRange[0] > pcMin || pcRange[1] < pcMax)) mc++;
        moreFiltersBadge.textContent = mc || ''; moreFiltersBadge.dataset.count = mc;

        // Op overview-view: geen filter toepassen op SVG (dat zijn side-polygons)
        const onOverview = isOverviewView();

        let visibleCount = 0;
        if (!onOverview) {
            svg.querySelectorAll('.hover-area').forEach(e => {
                const km = e.dataset.aantalKamers || e.dataset.aantalSlaapkamers || '';
                const k = {
                    status: statusToKey(e.dataset.status), naam: e.dataset.naam || '',
                    typewoning: e.dataset.typewoning || '', aantalKamers: km,
                    prijsNum: parsePrice(e.dataset.prijs),
                    woonoppervlakteNum: parseM2(e.dataset.woonoppervlakte),
                    perceeloppervlakteNum: parseM2(e.dataset.perceeloppervlakte)
                };
                const match = kavelMatchesFilters(k);
                e.classList.toggle('is-dimmed', !match);
                if (match) visibleCount++;
            });
        }

        let plCount = 0;
        pricelistBody.querySelectorAll('.pl-row').forEach(row => {
            const k = allKavels.find(x => x.id === row.dataset.id);
            if (k) { const m = kavelMatchesFilters(k); row.classList.toggle('is-dimmed', !m); if (m) plCount++; }
        });

        pricelistEmpty.style.display = plCount === 0 ? 'block' : 'none';

        // Counter: op overview tonen we het totaal aantal woningen (filtering telt alleen op lijst)
        let cnt;
        if (onOverview) {
            cnt = activeView === 'list' ? plCount : allKavels.length;
        } else {
            cnt = activeView === 'map' ? visibleCount : plCount;
        }
        resultsCounter.innerHTML = mobileResultsCounter.innerHTML = `<strong>${cnt}</strong> ${cnt === 1 ? 'woning' : 'woningen'}`;

        if (pinnedId) { const pe = svg.querySelector(`[data-id="${pinnedId}"]`); if (pe?.classList.contains('is-dimmed')) closePanel(); }
        if (isInitialized) updateUrlParams();
    }

    // --- Prijslijst ---
    function chip(icon, text, title) {
        return `<span class="lot-chip" title="${title}"><i class="fa fa-${icon} me-1"></i>${text}</span>`;
    }

    function renderPricelist() {
        const plCont = document.querySelector('.pricelist-container');
        if (plCont) plCont.classList.toggle('hide-perceel', !fc.showPc);

        const sorted = [...allKavels].sort((a, b) => {
            const MAP = {
                type: [a.naam+' '+a.typewoning, b.naam+' '+b.typewoning],
                woonoppervlakte: [a.woonoppervlakteNum, b.woonoppervlakteNum],
                perceeloppervlakte: [a.perceeloppervlakteNum, b.perceeloppervlakteNum],
                prijs: [a.prijsNum, b.prijsNum]
            };
            if (sortColumn === 'bouwnummer') return sortDirection === 'asc'
                ? a.bouwnummer.localeCompare(b.bouwnummer, 'nl', { numeric: true })
                : b.bouwnummer.localeCompare(a.bouwnummer, 'nl', { numeric: true });
            const [vA, vB] = MAP[sortColumn] || [a.bouwnummer, b.bouwnummer];
            if (typeof vA === 'string') return sortDirection === 'asc' ? vA.localeCompare(vB) : vB.localeCompare(vA);
            return sortDirection === 'asc' ? vA - vB : vB - vA;
        });

        pricelistBody.innerHTML = sorted.map(k => {
            const wl = k.woonlastenUrl ? `<div class="lot-meta"><i class="fa fa-calculator me-2"></i><a href="${k.woonlastenUrl}" target="_blank">Wat zijn mijn woonlasten?</a></div>` : '';
            const sl = situatieToLabels(k.situatie);
            const chips = [
                k.woonoppervlakte    ? chip('ruler-combined', k.woonoppervlakte, k.woonoppervlakte + ' woonoppervlakte') : '',
                k.perceeloppervlakte ? chip('vector-square', k.perceeloppervlakte + ' perceel', k.perceeloppervlakte + ' perceeloppervlakte') : '',
                k.volume             ? chip('cube', k.volume + ' m\u00B3', k.volume + ' m\u00B3 inhoud') : '',
                k.aantalKamers       ? chip('bed', k.aantalKamers + ' slpk', k.aantalKamers + ' slaapkamers') : '',
                k.kamersTotaal       ? chip('door-open', k.kamersTotaal + ' kamers', k.kamersTotaal + ' kamers totaal') : '',
                k.buitenruimte && parseFloat(k.buitenruimte) !== 0 ? chip('sun', k.buitenruimte + ' m\u00B2', k.buitenruimte + ' m\u00B2 buitenruimte') : '',
                k.parkeren           ? chip('square-parking', k.parkeren, k.parkeren) : '',
                k.ligging            ? chip('compass', k.ligging, 'Ligging: ' + k.ligging) : '',
                sl.length            ? chip('location-dot', sl.join(' \u00B7 '), 'Situatie') : ''
            ].join('');
            return `<div class="pl-row" data-id="${k.id}">
                <div class="pl-row-header"><div class="pl-grid">
                    <div>${k.bouwnummer}</div>
                    <div>${k.naam}${k.typewoning ? ' | ' + k.typewoning : ''}</div>
                    <div class="pl-col-woonopp">${k.woonoppervlakte}</div>
                    <div class="pl-col-perceel">${k.perceeloppervlakte || '-'}</div>
                    <div>${k.prijs}</div>
                    <div class="pl-status"><span class="pl-status-dot status-${k.status}"></span><span>${statusToLabel(k.status)}</span></div>
                    <div class="pl-col-arrow"><i class="fa fa-chevron-right"></i></div>
                </div></div>
                <div class="pl-row-panel"><div class="lot-panel status-${k.status}"><div class="lot-panel-inner">
                    <div class="lot-media"><img src="${k.afbeelding}" alt="${k.naam} ${k.bouwnummer}" loading="lazy"></div>
                    <div class="lot-body">
                        <div class="lot-head">
                            <div><div class="lot-number">Woning ${k.bouwnummer}</div><h3 class="lot-title">${k.naam}${k.typewoning ? ' | ' + k.typewoning : ''}</h3></div>
                            <div class="lot-price">${k.prijs}</div>
                        </div>
                        <div class="lot-chips">${chips}</div>
                        <div class="lot-actions"><a class="btn btn-primary-kk" href="${k.info}">Bekijk meer details <i class="fa fa-arrow-right ms-2"></i></a></div>
                        ${wl}
                    </div>
                </div></div></div>
            </div>`;
        }).join('');

        pricelistBody.querySelectorAll('.pl-row-header').forEach(h => {
            h.addEventListener('click', () => {
                const r = h.closest('.pl-row'), expanded = r.classList.contains('is-expanded');
                pricelistBody.querySelectorAll('.pl-row.is-expanded').forEach(x => x.classList.remove('is-expanded'));
                if (!expanded) r.classList.add('is-expanded');
            });
        });
        applyFilters();
    }

    // Sort
    document.querySelectorAll('.pricelist-header .pl-col[data-sort]').forEach(col => {
        col.addEventListener('click', () => {
            const ns = col.dataset.sort;
            sortDirection = sortColumn === ns ? (sortDirection === 'asc' ? 'desc' : 'asc') : 'asc';
            sortColumn = ns;
            document.querySelectorAll('.pricelist-header .pl-col').forEach(c => {
                c.classList.remove('sort-active');
                const i = c.querySelector('.sort-icon'); if (i) i.className = 'fa fa-sort sort-icon';
            });
            col.classList.add('sort-active');
            const ic = col.querySelector('.sort-icon'); if (ic) ic.className = `fa fa-sort-${sortDirection === 'asc' ? 'up' : 'down'} sort-icon`;
            renderPricelist();
        });
    });

    // View toggle
    function setActiveView(v) {
        activeView = v;
        viewMapBtn.classList.toggle('active', v === 'map'); viewListBtn.classList.toggle('active', v === 'list');
        viewMapBtnMobile.classList.toggle('active', v === 'map'); viewListBtnMobile.classList.toggle('active', v === 'list');
        mapContainer.style.display = v === 'map' ? '' : 'none';
        pricelistContainer.classList.toggle('is-active', v === 'list');
        applyFilters();
    }
    viewMapBtn.addEventListener('click', () => setActiveView('map'));
    viewListBtn.addEventListener('click', () => setActiveView('list'));
    viewMapBtnMobile.addEventListener('click', () => setActiveView('map'));
    viewListBtnMobile.addEventListener('click', () => setActiveView('list'));

    // Filter events
    filterStatus.addEventListener('change',  () => { activeStatusFilter  = filterStatus.value;  applyFilters(); });
    filterType.addEventListener('change',    () => { activeTypeFilter    = filterType.value.toLowerCase();   applyFilters(); });
    filterModel.addEventListener('change',   () => { activeModelFilter   = filterModel.value;   if (filterModelDropdown)    filterModelDropdown.value    = activeModelFilter;   applyFilters(); });
    filterBedrooms.addEventListener('change',() => { activeBedroomsFilter= filterBedrooms.value;if (filterBedroomsDropdown) filterBedroomsDropdown.value = activeBedroomsFilter;applyFilters(); });
    if (filterModelDropdown)    filterModelDropdown.addEventListener('change',    () => { activeModelFilter    = filterModelDropdown.value;    filterModel.value    = activeModelFilter;    applyFilters(); });
    if (filterBedroomsDropdown) filterBedroomsDropdown.addEventListener('change', () => { activeBedroomsFilter = filterBedroomsDropdown.value; filterBedrooms.value = activeBedroomsFilter; applyFilters(); });
    resetBtn.addEventListener('click', resetAllFilters);

    function resetAllFilters() {
        activeStatusFilter = activeTypeFilter = activeModelFilter = activeBedroomsFilter = '';
        [filterStatus, filterType, filterModel, filterBedrooms,
         filterStatusMobile, filterTypeMobile, filterModelMobile, filterBedroomsMobile,
         filterModelDropdown, filterBedroomsDropdown].forEach(s => { if (s) s.value = ''; });
        priceRange = [priceMin, priceMax]; m2Range = [m2Min, m2Max]; pcRange = [pcMin, pcMax];
        [priceSlider, priceSliderMobile].forEach(s => s?.set([priceMin, priceMax]));
        [m2Slider, m2SliderMobile, m2SliderDD].forEach(s => s?.set([m2Min, m2Max]));
        [pcSlider, pcSliderMobile, pcSliderDD].forEach(s => s?.set([pcMin, pcMax]));
        scale = 1; panX = 0; panY = 0; applyTransform(); applyFilters();
    }

    // Meer filters dropdown
    function openMoreFilters() {
        moreFiltersDropdown.classList.add('is-open'); moreFiltersBtn.classList.add('is-active');
        if (filterModelDropdown)    filterModelDropdown.value    = activeModelFilter;
        if (filterBedroomsDropdown) filterBedroomsDropdown.value = activeBedroomsFilter;
        if (m2SliderDD) m2SliderDD.set(m2Range);
        if (pcSliderDD) pcSliderDD.set(pcRange);
    }
    function closeMoreFilters() { moreFiltersDropdown.classList.remove('is-open'); moreFiltersBtn.classList.remove('is-active'); }
    moreFiltersBtn.addEventListener('click', e => { e.stopPropagation(); moreFiltersDropdown.classList.contains('is-open') ? closeMoreFilters() : openMoreFilters(); });
    document.addEventListener('click', e => { if (!moreFiltersDropdown.contains(e.target) && !moreFiltersBtn.contains(e.target)) closeMoreFilters(); });

    // Mobiele filter drawer
    function openFilterDrawer() {
        filterDrawer.classList.add('is-open'); filterDrawerOverlay.classList.add('is-visible'); document.body.style.overflow = 'hidden';
        filterStatusMobile.value = activeStatusFilter; filterTypeMobile.value = activeTypeFilter;
        filterModelMobile.value  = activeModelFilter;  filterBedroomsMobile.value = activeBedroomsFilter;
        if (priceSliderMobile) priceSliderMobile.set(priceRange);
        if (m2SliderMobile)    m2SliderMobile.set(m2Range);
        if (pcSliderMobile)    pcSliderMobile.set(pcRange);
    }
    function closeFilterDrawer() { filterDrawer.classList.remove('is-open'); filterDrawerOverlay.classList.remove('is-visible'); document.body.style.overflow = ''; }
    mobileFilterBtn.addEventListener('click', openFilterDrawer);
    filterDrawerClose.addEventListener('click', closeFilterDrawer);
    filterDrawerOverlay.addEventListener('click', closeFilterDrawer);
    filterDrawerReset.addEventListener('click', () => { resetAllFilters(); closeFilterDrawer(); });
    filterDrawerApply.addEventListener('click', () => {
        activeStatusFilter   = filterStatusMobile.value;
        activeTypeFilter     = filterTypeMobile.value.toLowerCase();  // lowercase voor filtering
        activeModelFilter    = filterModelMobile.value;
        activeBedroomsFilter = filterBedroomsMobile.value;
        if (priceSliderMobile) priceRange = priceSliderMobile.get();
        if (m2SliderMobile)    m2Range    = m2SliderMobile.get();
        if (pcSliderMobile)    pcRange    = pcSliderMobile.get();
        filterStatus.value = activeStatusFilter;
        filterType.value   = filterTypeMobile.value;  // originele waarde voor select
        filterModel.value  = activeModelFilter;
        filterBedrooms.value = activeBedroomsFilter;
        if (priceSlider) priceSlider.set(priceRange);
        if (m2Slider)    m2Slider.set(m2Range);
        if (pcSlider)    pcSlider.set(pcRange);
        applyFilters(); closeFilterDrawer();
    });

    // View navigatie - skip overview bij prev/next (navigatie tussen detail-views)
    function updateViewButtons() {
        // Single = geen navigatie mogelijk
        const singleDetail = detailViewIndices.length <= 1;
        const onOverview = isOverviewView();

        // Op overview: geen prev/next pijlen of select
        if (onOverview) {
            viewPrev.style.display = viewNext.style.display = viewSelect.style.display = 'none';
            return;
        }

        viewPrev.style.display = viewNext.style.display = viewSelect.style.display = singleDetail ? 'none' : '';

        // Bepaal positie in detail-views voor prev/next disabled state
        const detailPos = detailViewIndices.indexOf(currentViewIndex);
        viewPrev.disabled = detailPos <= 0;
        viewNext.disabled = detailPos >= detailViewIndices.length - 1;
    }
    
    // Helper: switch naar een specifieke view index en update URL
    function switchToView(idx) {
        if (idx < 0 || idx >= views.length) return;
        // Panel sluiten bij view-wissel
        if (isOpen) closePanel();
        currentViewIndex = idx;
        viewSelect.value = currentViewIndex;
        renderView(currentViewIndex);
        updateViewButtons();
        if (isInitialized) updateUrlParams();
    }

    // Navigeer naar volgende/vorige detail-view (skip overview)
    function navigateDetailView(direction) {
        const detailPos = detailViewIndices.indexOf(currentViewIndex);
        if (detailPos < 0) return; // we zitten niet op een detail-view
        const newPos = detailPos + direction;
        if (newPos < 0 || newPos >= detailViewIndices.length) return;
        switchToView(detailViewIndices[newPos]);
    }

    viewSelect.addEventListener('change', () => { switchToView(parseInt(viewSelect.value)); });
    viewPrev.addEventListener('click', () => navigateDetailView(-1));
    viewNext.addEventListener('click', () => navigateDetailView(1));

    // Terug-naar-overzicht knop
    if (btnBackOverview) {
        btnBackOverview.addEventListener('click', () => {
            if (hasOverview) switchToView(overviewIndex);
        });
    }

    // --- Tooltip (detail-views) ---
    function showTooltip(el, cx, cy) {
        if (isOpen) return;
        const d = el.dataset;
        const r = wrapper.getBoundingClientRect();
        let x = cx - r.left + 15, y = cy - r.top + 15;
        if (x + 280 > r.width - 20)  x = cx - r.left - 295;
        if (y + 240 > r.height - 20) y = cy - r.top - 255;
        tooltip.style.left = Math.max(10, x) + 'px';
        tooltip.style.top  = Math.max(10, y) + 'px';

        tooltip.querySelector('.tooltip-image').src = d.afbeelding || '';
        const bn = tooltip.querySelector('.tooltip-bouwnummer');
        if (bn) { bn.textContent = d.bouwnummer ? 'Woning ' + d.bouwnummer : ''; bn.style.display = d.bouwnummer ? 'block' : 'none'; }
        tooltip.querySelector('.tooltip-title').textContent = d.naam || d.typewoning || '';
        tooltip.querySelector('.tooltip-badge').textContent = statusToLabel(d.status);
        tooltip.querySelector('.tooltip-badge').className = 'tooltip-badge ' + statusToTooltipBadge(d.status);
        tooltip.querySelector('.tooltip-price').textContent = d.prijs || '';

        const km = d.aantalKamers || d.aantalSlaapkamers || '';
        const ts = (icon, text) => `<span class="tooltip-spec"><i class="fa fa-${icon}"></i> ${text}</span>`;
        tooltip.querySelector('.tooltip-specs').innerHTML = [
            d.woonoppervlakte    && parseFloat(d.woonoppervlakte)    !== 0 ? ts('ruler-combined', d.woonoppervlakte + ' m\u00B2') : '',
            d.perceeloppervlakte && parseFloat(d.perceeloppervlakte) !== 0 ? ts('vector-square', d.perceeloppervlakte + ' m\u00B2') : '',
            km ? ts('bed', km + ' slpk') : ''
        ].join('');
        tooltip.style.display = 'block';
    }

    // --- Tooltip (overview zijde) ---
    function showOverviewTooltip(el, cx, cy) {
        if (!tooltipOverview) return;
        const d = el.dataset;
        const r = wrapper.getBoundingClientRect();
        // Maak eerst zichtbaar voor dimensies
        tooltipOverview.style.display = 'block';
        tooltipOverview.style.left = '-9999px';
        tooltipOverview.querySelector('.tooltip-overview-title').textContent = d.label || '';
        tooltipOverview.querySelector('.tooltip-overview-sub').textContent = d.sublabel || '';

        // Positioneer naast de cursor, binnen wrapper
        const tw = tooltipOverview.offsetWidth || 200;
        const th = tooltipOverview.offsetHeight || 50;
        let x = cx - r.left + 15, y = cy - r.top + 15;
        if (x + tw > r.width - 10)  x = cx - r.left - tw - 15;
        if (y + th > r.height - 10) y = cy - r.top - th - 15;
        tooltipOverview.style.left = Math.max(10, x) + 'px';
        tooltipOverview.style.top  = Math.max(10, y) + 'px';
    }

    function hideTooltip() {
        tooltip.style.display = 'none';
        if (tooltipOverview) tooltipOverview.style.display = 'none';
    }

    function getHoverAreaAtPoint(x, y) {
        return document.elementsFromPoint(x, y).find(e => e.classList?.contains('hover-area'));
    }
    function getSidePolygonAtPoint(x, y) {
        return document.elementsFromPoint(x, y).find(e => e.classList?.contains('side-polygon'));
    }

    let currentHoverEl = null;
    svg.addEventListener('mousemove', e => {
        if (isOpen) return;

        // Overview modus: hover op side-polygons
        if (isOverviewView()) {
            const hov = getSidePolygonAtPoint(e.clientX, e.clientY);
            if (hov !== currentHoverEl) {
                if (currentHoverEl) {
                    currentHoverEl.classList.remove('is-hovering');
                    if (currentHoverEl._sideLabel) currentHoverEl._sideLabel.classList.remove('is-active');
                }
                currentHoverEl = hov;
                if (hov) {
                    hov.classList.add('is-hovering');
                    svg.appendChild(hov);
                    // Sync hover state naar bijbehorend label
                    if (hov._sideLabel) hov._sideLabel.classList.add('is-active');
                }
            }
            // Overview tooltip wordt niet meer gebruikt: het permanente label
            // toont al de info. Zorg dat 'm verborgen is.
            hideTooltip();
            return;
        }

        // Detail-view: normale hover-area logica
        const hov = getHoverAreaAtPoint(e.clientX, e.clientY);
        if (hov !== currentHoverEl) {
            if (currentHoverEl) currentHoverEl.classList.remove('is-hovering');
            currentHoverEl = hov;
            if (hov && !hov.classList.contains('is-dimmed')) { hov.classList.add('is-hovering'); svg.appendChild(hov); }
        }
        if (!hov || hov.classList.contains('is-dimmed')) { hideTooltip(); return; }
        showTooltip(hov, e.clientX, e.clientY);
    });
    svg.addEventListener('mouseleave', () => {
        hideTooltip();
        if (currentHoverEl) {
            currentHoverEl.classList.remove('is-hovering');
            if (currentHoverEl._sideLabel) currentHoverEl._sideLabel.classList.remove('is-active');
            currentHoverEl = null;
        }
    });

    // --- Details panel ---
    function openPanel(el) {
        const d = el.dataset;
        svg.querySelectorAll('.hover-area').forEach(p => p.classList.remove('is-selected', 'is-hovering'));
        el.classList.add('is-selected'); svg.classList.add('has-selection');

        setText('detailsType', d.naam || '');
        const statusEl = $('detailsStatus');
        statusEl.textContent = statusToLabel(d.status); statusEl.className = 'badge ' + statusToBadgeClass(d.status);
        $('detailsImage').src = d.afbeelding || '';
        setText('detailsTitle', d.bouwnummer ? 'Woning ' + d.bouwnummer : d.naam || '');
        setText('detailsPrice', d.prijs || '');

        // Spec-tags
        const m2Val = d.woonoppervlakte && parseFloat(d.woonoppervlakte) !== 0 ? d.woonoppervlakte + ' m\u00B2' : '-';
        setText('detailsM2', m2Val);
        const m2Tag = $('detailsM2')?.closest('.spec-tag');
        if (m2Tag) m2Tag.title = m2Val !== '-' ? m2Val + ' woonoppervlakte' : '';

        const km = d.aantalKamers || d.aantalSlaapkamers || '';
        const slpk = km.replace(/[^\d]/g, '') || '-';
        setText('detailsSlaapkamers', slpk);
        const slpkTag = $('detailsSlaapkamers')?.closest('.spec-tag');
        if (slpkTag) slpkTag.title = slpk !== '-' ? slpk + ' slaapkamer' + (slpk !== '1' ? 's' : '') : '';

        const pcVal = d.perceeloppervlakte && parseFloat(d.perceeloppervlakte) !== 0 ? d.perceeloppervlakte + ' m\u00B2' : '-';
        setText('detailsPerceel2', pcVal !== '-' ? pcVal : '');
        showTag('detailsPerceelTag', pcVal !== '-');
        // Perceel staat al als spec-tag, niet ook in kenmerken tabel tonen
        showDd('detailsPerceel', false);

        const kt = d.kamersTotaal && parseInt(d.kamersTotaal) > 0 ? d.kamersTotaal : '';
        // Kamers totaal: alleen in kenmerken tabel, niet als spec-tag
        showTag('detailsKamersTotaalTag', false);

        const pl = parkerenLabel(d.parkeren, d.parkerenAantal);
        // Parkeren: alleen in kenmerken tabel, niet als spec-tag
        showTag('detailsParkerenTag', false);
        setText('detailsParkeren', pl || '-'); showDd('detailsParkeren', !!pl);

        // Kenmerken dl
        setText('detailsBouwtype', d.naam || '');
        setText('detailsKamersTotaal2', kt); showDd('detailsKamersTotaal2', !!kt);
        const volShow = d.volume && parseFloat(d.volume) > 0;
        setText('detailsVolume', volShow ? d.volume + ' m\u00B3' : '-'); showDd('detailsVolume', volShow);
        setText('detailsVerdieping', d.verdieping ? (d.verdieping === '0' ? 'Begane grond' : d.verdieping + 'e') : '-');
        showDd('detailsVerdieping', !!d.verdieping);
        const bShow = d.buitenruimte && parseFloat(d.buitenruimte) !== 0;
        setText('detailsBuitenruimte', bShow ? d.buitenruimte + ' m\u00B2' : '-'); showDd('detailsBuitenruimte', bShow);
        setText('detailsLigging', d.ligging || '-'); showDd('detailsLigging', !!d.ligging);
        const sl = situatieToLabels(d.situatie);
        setText('detailsSituatie', sl.join(' \u00B7 ') || '-'); showDd('detailsSituatie', sl.length > 0);

        $('detailsInschrijven').href = d.info || '#';
        $('detailsInfo').href = d.info || '#';
        // Mobiele sticky CTA ook updaten (als aanwezig)
        const mobileCtaBtn = $('detailsInfoMobile');
        if (mobileCtaBtn) mobileCtaBtn.href = d.info || '#';
        panel.classList.add('is-open'); isOpen = true; pinnedId = d.id; hideTooltip();
    }

    function closePanel() {
        panel.classList.remove('is-open'); isOpen = false; pinnedId = null;
        svg.querySelectorAll('.hover-area.is-selected').forEach(p => p.classList.remove('is-selected'));
        svg.classList.remove('has-selection');
    }

    // Klik op side-polygon (overview) → navigeer naar target-view
    function handleSidePolygonClick(el) {
        const targetId = el.dataset.targetViewId;
        if (!targetId) { console.warn('Kavelkiezer: side-polygon heeft geen data-target-view-id'); return; }
        const targetIdx = views.findIndex(v => v.id === targetId);
        if (targetIdx < 0) { console.warn('Kavelkiezer: target view niet gevonden:', targetId); return; }
        switchToView(targetIdx);
    }

    svg.addEventListener('click', e => {
        // Overview modus: klik op zijde → naar target-view
        if (isOverviewView()) {
            const side = getSidePolygonAtPoint(e.clientX, e.clientY);
            if (side) handleSidePolygonClick(side);
            return;
        }

        // Detail-view: bestaande woning-click logica
        const hov = getHoverAreaAtPoint(e.clientX, e.clientY);
        if (!hov || hov.classList.contains('is-dimmed')) return;
        hov.classList.contains('is-selected') ? closePanel() : openPanel(hov);
    });

    svg.addEventListener('keydown', e => {
        if (e.key !== 'Enter' && e.key !== ' ') return;

        // Overview modus: toetsenbord-navigatie op side-polygons
        if (isOverviewView()) {
            const side = e.target.closest('.side-polygon');
            if (side) { e.preventDefault(); handleSidePolygonClick(side); }
            return;
        }

        const hov = e.target.closest('.hover-area');
        if (!hov || hov.classList.contains('is-dimmed')) return;
        e.preventDefault(); hov.classList.contains('is-selected') ? closePanel() : openPanel(hov);
    });
    $('detailsClose').addEventListener('click', closePanel);
    overlayBg.addEventListener('click', closePanel);
    document.addEventListener('keydown', e => { if (e.key === 'Escape') closePanel(); });

    // --- Zoom & pan ---
    function applyTransform() {
        const t = `matrix(${scale},0,0,${scale},${panX},${panY})`;
        bgImg.style.transform = svg.style.transform = t;
        wrapper.classList.toggle('draggable', scale > 1 && !isOpen);
    }
    function constrainPan() {
        const vw = wrapper.clientWidth, vh = wrapper.clientHeight;
        panX = Math.max(Math.min(0, vw - vw * scale), Math.min(panX, 0));
        panY = Math.max(Math.min(0, vh - vh * scale), Math.min(panY, 0));
    }
    function zoomAt(cx, cy, f) {
        if (isOpen) return; hideTooltip();
        const r = wrapper.getBoundingClientRect();
        const px = (cx - r.left - panX) / scale, py = (cy - r.top - panY) / scale;
        scale = Math.max(MIN_SCALE, Math.min(MAX_SCALE, scale * f));
        panX = cx - r.left - px * scale; panY = cy - r.top - py * scale;
        constrainPan(); applyTransform();
    }
    document.querySelector('.zoom-controls').addEventListener('click', e => {
        const btn = e.target.closest('button'); if (!btn || btn.id === 'toggleOverlay') return;
        const r = wrapper.getBoundingClientRect(), cx = r.left + r.width / 2, cy = r.top + r.height / 2;
        if (btn.dataset.zoom === 'in')    zoomAt(cx, cy, 1.3);
        if (btn.dataset.zoom === 'out')   zoomAt(cx, cy, 1 / 1.3);
        if (btn.dataset.zoom === 'reset') { scale = 1; panX = 0; panY = 0; applyTransform(); }
    });
    wrapper.addEventListener('wheel', e => {
        if (isOpen || !e.ctrlKey || isOverviewView()) return;
        e.preventDefault(); zoomAt(e.clientX, e.clientY, e.deltaY < 0 ? 1.1 : 1 / 1.1);
    }, { passive: false });
    wrapper.addEventListener('pointerdown', e => {
        if (isOpen || e.target.closest('button, select') || scale <= 1 || isOverviewView()) return;
        hideTooltip(); wrapper.classList.add('panning');
        let lx = e.clientX, ly = e.clientY;
        const onMove = ev => { panX += ev.clientX - lx; panY += ev.clientY - ly; lx = ev.clientX; ly = ev.clientY; constrainPan(); applyTransform(); };
        const onUp   = () => { wrapper.classList.remove('panning'); window.removeEventListener('pointermove', onMove); window.removeEventListener('pointerup', onUp); };
        window.addEventListener('pointermove', onMove); window.addEventListener('pointerup', onUp);
    });
    $('toggleOverlay').addEventListener('click', function() {
        const h = svg.style.display === 'none'; svg.style.display = h ? '' : 'none';
        this.querySelector('i').className = h ? 'fa fa-eye' : 'fa fa-eye-slash';
    });

    // --- URL params ---
    function updateUrlParams() {
        const p = new URLSearchParams();
        if (activeStatusFilter)  p.set('status', activeStatusFilter);
        if (activeTypeFilter)    p.set('type', activeTypeFilter);
        if (activeModelFilter)   p.set('model', activeModelFilter);
        if (activeBedroomsFilter)p.set('slaapkamers', activeBedroomsFilter);
        if (fc.showPr && (priceRange[0] > priceMin || priceRange[1] < priceMax)) p.set('prijs',   priceRange.join('-'));
        if (fc.showM2 && (m2Range[0] > m2Min || m2Range[1] < m2Max))            p.set('woonopp', m2Range.join('-'));
        if (fc.showPc && (pcRange[0] > pcMin || pcRange[1] < pcMax))            p.set('perceel', pcRange.join('-'));
        if (activeView === 'list') p.set('weergave', 'lijst');
        // Zijde toevoegen aan URL (alleen als niet de eerste view)
        // NB: overview niet als zijde toevoegen — dat is de default landing
        if (currentViewIndex > 0 && views[currentViewIndex] && views[currentViewIndex].type !== 'overview') {
            p.set('zijde', views[currentViewIndex].id);
        }
        history.replaceState({}, '', p.toString() ? location.pathname + '?' + p : location.pathname);
    }
    
    function readUrlParams() {
        const p = new URLSearchParams(location.search);
        const st = p.get('status'); if (st && kavelData.statuses.includes(st)) { activeStatusFilter = st; filterStatus.value = st; filterStatusMobile.value = st; }
        // Type: zoek originele waarde (met hoofdletters) voor select, maar filter lowercase
        const ty = p.get('type');
        if (ty) {
            const originalType = kavelData.types.find(t => t.toLowerCase() === ty.toLowerCase());
            if (originalType) {
                activeTypeFilter = ty.toLowerCase();
                filterType.value = originalType;
                filterTypeMobile.value = originalType;
            }
        }
        const mo = p.get('model');  if (mo && kavelData.models.includes(mo)) { activeModelFilter = mo; filterModel.value = mo; filterModelMobile.value = mo; }
        const sl = p.get('slaapkamers'); if (sl && kavelData.bedrooms.includes(sl)) { activeBedroomsFilter = sl; filterBedrooms.value = sl; filterBedroomsMobile.value = sl; }
        const setPair = (key, mn, mx, range, sliders) => {
            const v = p.get(key); if (!v?.includes('-')) return;
            const [a, b] = v.split('-').map(Number);
            if (!isNaN(a) && !isNaN(b) && a >= mn && b <= mx) { range[0] = a; range[1] = b; sliders.forEach(s => s?.set([a, b])); }
        };
        setPair('prijs',   priceMin, priceMax, priceRange, [priceSlider, priceSliderMobile]);
        setPair('woonopp', m2Min,    m2Max,    m2Range,    [m2Slider, m2SliderMobile]);
        setPair('perceel', pcMin,    pcMax,    pcRange,    [pcSlider, pcSliderMobile]);
        if (p.get('weergave') === 'lijst') setActiveView('list');
        
        // Bepaal welke view als landing wordt getoond:
        // 1. Als er een ?zijde= in URL staat → die view (skip overview)
        // 2. Als er filters in URL staan → skip overview, toon eerste detail-view
        // 3. Anders → overview als landing (indien aanwezig), anders eerste detail-view
        const zijde = p.get('zijde');
        const hasActiveFilters = !!(activeStatusFilter || activeTypeFilter || activeModelFilter
            || activeBedroomsFilter || p.get('prijs') || p.get('woonopp') || p.get('perceel'));

        let landingIdx = -1;

        if (zijde) {
            // Specifieke zijde in URL
            const idx = views.findIndex(v => v.id === zijde);
            if (idx >= 0) landingIdx = idx;
        }

        if (landingIdx < 0 && hasActiveFilters) {
            // Filters actief → eerste detail-view (skip overview)
            landingIdx = detailViewIndices[0] !== undefined ? detailViewIndices[0] : 0;
        }

        if (landingIdx < 0) {
            // Standaard landing: overview indien aanwezig, anders eerste view
            landingIdx = hasOverview ? overviewIndex : 0;
        }

        currentViewIndex = landingIdx;
    }

    // Open detail-links in parent als we in een iframe zitten
    document.addEventListener('click', e => {
        const a = e.target.closest('a[href]');
        if (!a) return;
        const href = a.getAttribute('href');
        if (!href || href === '#') return;
        if (window.self !== window.top) {
            e.preventDefault();
            window.top.location.href = href;
        }
    });

    // Init - volgorde is belangrijk:
    // 1. Eerst URL params lezen (incl. zijde + overview-landing logica)
    // 2. Dan view renderen met de juiste index
    // 3. Rest initialiseren
    readUrlParams();
    renderView(currentViewIndex);
    viewSelect.value = currentViewIndex;
    renderPricelist();
    applyFilters();
    updateViewButtons();
    isInitialized = true;
})();